export default __webpack_public_path__ + "static/media/Stripelarge.4f336307.svg";